import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../features/auth";

type MapGismeteoPrecipitationSlice = {
    time: string,
    timeMarkIndex: number
}

function getInitialState() {
    const currentTime = new Date();
    // Округляем текущее время вниз до ближайших 10 минут
    currentTime.setMinutes(Math.floor(currentTime.getMinutes() / 10) * 10, 0, 0);
    let currentTimeString = currentTime.toISOString()
    const initialState: MapGismeteoPrecipitationSlice = {
        time: currentTimeString,
        timeMarkIndex: 2
    }
    return initialState;
}

export const mapGismeteoPrecipitationSlice = createSlice({
    name: 'mapGismeteoPrecipitation',
    initialState: getInitialState(),
    reducers: {
        setTime(state, action: PayloadAction<{ time: string, timeMarkIndex: number }>) {
            const { time, timeMarkIndex } = action.payload
            state.time = time
            state.timeMarkIndex = timeMarkIndex
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { setTime } = mapGismeteoPrecipitationSlice.actions
export const mapGismeteoPrecipitationReducer = mapGismeteoPrecipitationSlice.reducer;
